const defaultBoundaryFormatter = value => value.toLocaleString()

export const DEFAULT_MAX_DOLLAR_VALUE = 999999999

export const minMaxValidator = (min, max, formatter = defaultBoundaryFormatter) => (value, touched) => {
  if ((value === null && !touched) || (value >= min && value <= max)) {
    return undefined
  }

  return `Value must be between ${formatter(min)} and ${formatter(max)}.`
}

export default {
  minMaxValidator,
}



// WEBPACK FOOTER //
// ./src/utils/validators/index.js